import React from 'react';
import abiliologo from '../src/abiliologo.png'

function App() {
  return (
    <>
      <style>{`
        * {
          box-sizing: border-box;
        }

        body {
          font-family: Arial, sans-serif;
          background: linear-gradient(to right, #1C1F48, #2B4D72);
          color: white;
          text-align: center;
          height: 100vh;
          margin: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
        }

        .container {
          max-width: 600px;
          width: 100%;
        }

        h1 {
          font-size: 65px;
          font-weight: 600;
          margin: 20px 0 10px;
        }

        p {
          font-size: 16px;
          margin-top: 10px;
          opacity: 0.8;
          color: #81A6CB;
        }

        .contact {
          display: flex;
          justify-content: space-evenly;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 20px;
        }

        strong {
          color: #81A6CB;
          font-size: 16px;
        }

        .img-logo {
          margin-top: 40px;
        }

        .img-logo img {
          max-width: 40%;
          height: auto;
        }

        @media (max-width: 768px) {
          h1 {
            font-size: 48px;
          }

          p {
            font-size: 15px;
          }
        }

        @media (max-width: 480px) {
          h1 {
            font-size: 36px;
            margin-bottom:20px;
          }

            .img-logo img {
          max-width: 80%;
          height: auto;
        }

          p {
            font-size: 14px;
            padding: 0 10px;
          }

          .contact {
            align-items: center;
          }

          strong {
            font-size: 14px;
          }
            img{
            margin-bottom:20px
            }
        }
      `}</style>

      <div className="container">
        <div className="img-logo">
          <img src={abiliologo} alt="Abilio Logo" />
        </div>
        <h1>Thank you for reaching out to us!</h1>
        <p>We’ve received your details, and our team will contact you soon.</p>
        <div className="contact">
          <strong><a href="mailto:info@abilioit.com" style={{ color: '#81A6CB', textDecoration: 'none' }}>info@abilioit.com</a></strong>
          <strong><a href="tel:+918019120404" style={{ color: '#81A6CB', textDecoration: 'none' }}>+91 80191 20404</a></strong>
        </div>
      </div>
    </>
  );
}

export default App;
